import { render, staticRenderFns } from "./DestinationBox.vue?vue&type=template&id=0393fd4a"
import script from "./DestinationBox.vue?vue&type=script&lang=js"
export * from "./DestinationBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports